import React, {useEffect} from "react";
import {Provider} from "react-redux";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {ThemeSwitcherProvider} from "react-css-theme-switcher";
import store from "./store";
import Layouts from "./layouts";
import {THEME_CONFIG} from "./configs/AppConfig";
import "./lang";
import ServerAPIService from "./services/ServerAPIService";
import {
    CUSTOM_APP_NAME,
    CUSTOM_PRIMARY_BASE,
    CUSTOM_SECONDARY_BASE,
    CUSTOM_POWERED_BY,
} from "./constants/AuthConstant";
import {notification} from "antd";

const themes = {
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const router = createBrowserRouter(
    [
        {
            path: "*",
            element: <Layouts/>,
        },
    ],
    {
        future: {
            v7_startTransition: true,
        },
    }
);

function App() {
    useEffect(() => {
        ServerAPIService("GET", "auth", {
            clientSettings: true,
            limitedColumns: true,
        }).then((resp) => {
            try {
                document.title = resp.data.dataMap.companyName;
                localStorage.setItem(CUSTOM_APP_NAME, resp.data.dataMap.companyName);
                localStorage.setItem(CUSTOM_PRIMARY_BASE, resp.data.dataMap.primaryColor);
                localStorage.setItem(CUSTOM_SECONDARY_BASE, resp.data.dataMap.secondaryColor);
                localStorage.setItem(CUSTOM_POWERED_BY, resp.data.dataMap.poweredBy);
            } catch (e) {
                notification.error({message: "Unable to connect to backoffice"});
            }
        });
    }, []);

    return (
        <div className="App">
            <Provider store={store}>
                <ThemeSwitcherProvider
                    themeMap={themes}
                    defaultTheme={THEME_CONFIG.currentTheme}
                    insertionPoint="styles-insertion-point">
                    <RouterProvider router={router}/>
                </ThemeSwitcherProvider>
            </Provider>
        </div>
    );
}

export default App;
